import React from 'react';
import { Modal as BSModal } from 'react-bootstrap';
import { isNullOrEmpty } from '../../utils/core';
import '../../../css/modal.less';

const Modal = ({
    // Header props
    renderHeader,
    title = '',
    onHide,
    headerClassName,
    // Body props
    renderBody,
    bodyClassName,
    // Footer props
    renderFooter,
    footerClassName,
    // Backdrop props
    backdropClassName,
    // Modal props
    animation,
    container, 
    dialogClassName,
    className,
    show = true,
}) => {

    const defaultContainer = document.getElementById('generic-modal');
    const modalContainer = container || defaultContainer;

    const modalProps = {
        animation,
        show,
        onHide,
        dialogClassName,
        className,
        container: modalContainer,
        backdropClassName,
        backdrop: 'static',
    };

    const header = renderHeader || title ? 
        (
            <BSModal.Header closeButton={isNullOrEmpty(onHide) === false} className={headerClassName}>
                {
                    renderHeader ? renderHeader() : <BSModal.Title>{title}</BSModal.Title>
                }                
            </BSModal.Header>
        ) : null;

    const body = renderBody ? 
        (
            <BSModal.Body className={bodyClassName}>
                {renderBody()}
            </BSModal.Body>
        ) : null;

    const footer = renderFooter ? 
        (
            <BSModal.Footer className={footerClassName}>
                {renderFooter()}
            </BSModal.Footer>
        ) : null;

    return (
        <BSModal {...modalProps}>
            {header}
            {body}
            {footer}
        </BSModal>
    );
};

export default Modal;
